import { Component } from 'preact'
import CategoryListItem from './CategoryListItem'
import $ from 'jquery'
import ShowMoreButton from '../ui-components/ShowMoreButton'

class CategoryList extends Component {
  constructor () {
    super()
    this.maxItem = 6
    this.state = {
      list: [],
      displayedAllItems: true
    }
    this.showMore = this.showMore.bind(this)
  }

  componentDidMount () {
    $.get('/category/list', {
      'id': this.props.id
    }).then(function (list) {
      this.setState({ list, displayedAllItems: list.length <= this.maxItem })
    }.bind(this))
  }

  showMore () {
    this.setState({ displayedAllItems: true })
  }

  render (props, state) {
    const list = state.displayedAllItems ? state.list : state.list.slice(0, this.maxItem)
    return (
      <div className='category-page_container'>
        <ul className='category-page_list'>
          {
            list.map((item) => <CategoryListItem {...item} />)
          }
        </ul>
        {
          !state.displayedAllItems ? <ShowMoreButton callback={this.showMore} count={state.list.length - this.maxItem} /> : null
        }
      </div>
    )
  }
}

export default CategoryList
